<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  topicId: { type: Number, required: true },
});

const getTopicById = useMapGetter('mhTopics/getTopicById');
const getBadgeFor = useMapGetter('mhTopics/getBadgeFor');
const { t } = useI18n();
const topic = computed(() => getTopicById.value(props.topicId));
const badge = computed(() => getBadgeFor.value(props.topicId));
const badgeLabel = computed(() =>
  badge.value > 99 ? t('MH_TOPICS.BADGE_OVERFLOW') : badge.value
);
</script>

<template>
  <div class="flex flex-1 items-center gap-2 min-w-0">
    <span class="flex-1 truncate min-w-0 text-sm">{{ topic?.name }}</span>
    <span
      v-if="badge"
      class="shadow-lg rounded-full text-xxs font-semibold h-4 leading-4 min-w-[1rem] px-1 py-0 text-center bg-n-ruby-9 text-white flex-shrink-0"
    >
      {{ badgeLabel }}
    </span>
  </div>
</template>
